// eslint-disable-next-line import/prefer-default-export
export const API_LINK = process.env.REACT_APP_MY_VAR;
export const STORAGE_LINK = "https://alex-shaun.s3.af-south-1.amazonaws.com/";
export const SERVER_LINK = "https://alexstaging.cpslearn.co.za/";

export const STATUSES = {
  notStarted: { name: 'not started', value: 1 , display:'NOT STARTED'},
  inProgress: { name: 'in progress', value: 2 , display:'IN PROGRESS'},
  completed: { name: 'completed', value: 3 , display:'COMPLETED'},
  locked: { name: 'locked', value: 4, display:'LOCKED' },
  ready: { name: 'ready', value: 5, display:'READY' },
  extension_request:{name: 'extension_request', value: 6 , display:'EXTENSION REQUESTED'},
  resubmission_request:{name: 'resubmission_request', value: 7 , display:'RESUBMISSION REQUESTED'},
  marking:{name: 'marking', value: 8 , display:'MARKING'},
  declined:{name: 'declined', value: 9 , display:'DECLINED'},
  passed:{name: 'passed', value: 10 , display:'PASSED'},
  submitted:{name: 'submitted', value: 11 , display:'SUBMITTED'},
  overdue:{name: 'overdue', value: 12 , display:'OVERDUE'},
};

export const MESSAGE_TYPES = [
  { id: 1, color:'primary-color', name:'Admin' },
  { id: 2, color:'primary-color', name:'Invite'},
  { id: 3, color:'primary-color', name:'Alert' },
  { id: 4 , color:'primary-color', name:'Notification'},
  { id: 5 , color:'primary-color', name:'Coach'},
  { id: 6 , color:'primary-color', name:'Team'},
  { id: 7 , color:'primary-color', name:'Reponse'},
  { id: 8 , color:'primary-color', name:'Invite'},
  { id: 9 , color:'primary-color', name:'Declined'},
  { id: 10 , color:'primary-color', name:'Admin'},
  { id: 11 , color:'success-color', name:'Announcement'},
];

/* eslint-disable */
export const FOOTER_TEXTS = {
  privacy: '<div><div id="Content">\n' +
  '<div class="boxed"><!-- \n' +
  '\n' +
  '\n' +
  'If you want to use Lorem Ipsum within another program please contact us for details\n' +
  'on our API rather than parse the HTML below, we have XML and JSON available.\n' +
  '\n' +
  '\n' +
  ' --><div id="lipsum">\n' +
  '<p>\n' +
  'Cornerstone Performance Solutions is committed to protecting your privacy. This privacy policy applies to all web pages related to this website, as well as social media pages and any other verified web properties associated with Cornerstone Performance Solutions (“properties”). All of the information gathered via these Properties (“data”) is used to identify users that use this site and/or interact with our brand online. \n' +
  '</p>\n' +
  '<p>\n' +
  'Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle your personally identifiable information. \n' +
  '</p>\n' +
  '<p>\n' +
  'By using this site, you signify your acceptance of our Privacy Policy. You also agree not to: circumvent, remove, alter, deactivate, degrade or thwart any of the content protections on this site; use any robot, spider, scraper or other automated means to access this site; decompile, reverse engineer or disassemble any software or other products or processes accessible through this site; insert any code or product or manipulate the content of this site in any way; or, use any data mining, data gathering or extraction method. In addition, you agree not to upload, post, e-mail or otherwise send or transmit any material designed to interrupt, destroy or limit the functionality of any computer software or hardware or telecommunications equipment associated with this site, including any software viruses or any other computer code, files or programs. If you do not agree to this policy, please do not make use of this site.\n' +
  '</p>\n' +
  '<p>\n' +
  '1. What personal information do we collect?\n' +
  '</p>\n' +
  '<p>\n' +
  'This site uses Google Analytics tracking to collect data about your visit, including: duration, device used, pages visited, actions taken, geographical location (region, country and city), age (generalised), gender, date, time of day, the name of the Internet service provider and the Internet Protocol (IP) address through which you access the Internet and the Internet address of the website from which you linked directly to our site. Google Analytics does not yield any piece of information that can be used in isolation to identify you personally.\n' +
  '</p>\n' +
  '<p>\n' +
  'When ordering from us, completing a contact form, or subscribing to our newsletter, you may be asked to enter your name, email address or other personal details. \n' +
  '</p>\n' +
  '<p>\n' +
  'By using this site, you signify your acceptance of our Privacy Policy. You also agree not to: circumvent, remove, alter, deactivate, degrade or thwart any of the content protections on this site; use any robot, spider, scraper or other automated means to access this site; decompile, reverse engineer or disassemble any software or other products or processes accessible through this site; insert any code or product or manipulate the content of this site in any way; or, use any data mining, data gathering or extraction method. In addition, you agree not to upload, post, e-mail or otherwise send or transmit any material designed to interrupt, destroy or limit the functionality of any computer software or hardware or telecommunications equipment associated with this site, including any software viruses or any other computer code, files or programs. If you do not agree to this policy, please do not make use of this site.\n' +
  '</p>\n' +
  '<p>\n' +
  'You may elect (at your sole discretion) to enter your personal information into a form embedded on this site. Such information can be used to identify you personally and typically includes: your names, date of birth, contact information, address information and employment information. Likewise, should you enter into any competition run by the Providers, either via this site or one of our other Properties, you acknowledge that you do so knowingly and at your own discretion. \n' +
  '<p>\n' +
  '2. How do we use of information that is collected?\n' +
  '</p>\n' +
  '<p>\n' +
  'This information is used to help improve the site, analyse trends, and further administer this site. We may also use this information internally to improve our products and services. We may need to change this policy from time to time in order to address new issues and reflect changes on our website. We will post those changes here so that you will always know what information we gather, how we might use that information, and whether we will disclose that information to anyone else. \n' +
  '</p>\n' +
  '<p>\n' +
  'Information that you enter into a contact form on this website will be used to contact you and assist with any enquiry that is raised through that form. In addition, information that you enter into a newsletter subscription form on this website will be used to send you newsletter updates. Please see the section titled ‘Communication Preferences’ in our Website Terms of Use for further details.  \n' +
  '</p>\n' +
  '<p>\n' +
  'Your contact details will not be automatically added to our marketing communication database. Instead, the providers make use of double opt-in mechanisms to guarantee that all persons who receive marketing communication from Cornerstone Performance Solutions have explicitly opted in to do so. This form of consent is unambiguous, specific and given freely. You can withdraw your consent at any time by following the instructions provided in these communications. \n' +
  '</p>\n' +
  '<p>\n' +
  'Data that is collected will not be used for any purpose other than that which is stated in these terms. \n' +
  '</p>' +
  '3. Do we use cookies?\n' +
  '</p>\n' +
  '<p>\n' +
  'Yes. Please refer to our Cookie Policy for more information.\n' +
  '</p>\n' +
  '<p>\n' +
  '4. Storage of information \n' +
  '</p>\n' +
  '<p>\n' +
  'The providers endeavour to store all data securely at all times. Data may be stored locally and/or using trusted, verified tools offered by third-party providers. Every effort is made to ensure data safety (including, but not limited to: enforcement of strong password policies, encryption, activity notifications, database maintenance, off-site back-up and automatic back-up). By choosing to use and/or enter your information on this website, you acknowledge and agree that the providers will not be held responsible for any breach or similar lapse in security on the part of third-party providers whose tools are used to store or process data, howsoever caused. \n' +
  '</p>\n' +
  '<p>\n' +
  'Please refer back to this policy regularly.  \n' +
  '<p>\n' +
  '5. Third-party disclosure\n' +
  '</p>\n' +
  '<p>\n' +
  'We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when its release is appropriate to comply with the law, enforce our site policies, or protect ours or others’ rights, property, or safety. However, non-personally identifiable visitor information may be provided to other parties for marketing, advertising, or other uses.\n' +
  '</p>\n' +
  '<p>\n' +
  '6. Third-party links \n' +
  '</p>\n' +
  '<p>\n' +
  'Occasionally, at our discretion, we may include or offer third-party products or services on our website. These third-party sites have separate and independent privacy policies. We therefore have no responsibility or liability for the content and activities of these linked sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites. \n' +
  '</p>\n' +
  '<p>\n' +
  '7. CAN-SPAM Act  \n' +
  '<p>\n' +
  'The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial messages, gives recipients the right to have emails stopped from being sent to them. We collect your email address in order to send you newsletters and promotional emails about our products and services. If at any time you would like to unsubscribe from receiving future emails, you can email us at info@performancesolutions.co.za and we will promptly remove you from all correspondence. If there are any questions regarding this privacy policy please contact us.?\n' +
  '</p>\n' +
  '<p>\n' +
  '8. Notes\n' +
  '</p>\n' +
  '<p>\n' +
  'Cornerstone Performance Solutions may from time to time change this Privacy Policy and other terms of service, or change, modify or withdraw access to this site at any time with or without notice. \n' +
  '</p>\n' +
  '<p>\n' +
  '9. Data Protection Officer \n' +
  '</p>\n' +
  '<p>\n' +
  'Information gathered through Cornerstone Performance Solutions’ web properties is processed by Cornerstone Performance Solutions. Please direct any concerns or enquiries regarding this Privacy Policy to :   \n' +
  '<p>\n' +
  'Email: info@performancesolutions.co.za\n' +
  '</p>\n' +
  '<p>\n' +
  'Phone: +27 11 789 1957\n' +
  '</p>\n' +
  '</p>\n' +
  '<p>\n' +
  '</p></div>\n' +
  '</div>\n' +
  '<div id="bannerL"><div id="div-gpt-ad-1474537762122-2">\n' +
  '</div></div>\n' +
  '</div></div>',
  support: '<div><div id="Content">\n' +
  '<div class="boxed"><!-- \n' +
  '\n' +
  '\n' +
  '1.	OVERVIEW\n' +
  'Please note the following terms of service (“terms”) which govern the use of this website (“the/this website”), the mobile app and which govern the use of Cornerstone Performance Solutions’ products and the components and materials from which they are made (“products”). By using this website, app and our products, you (“the purchaser(s)” and/or “the user(s)”, whichever applies) agree that you shall follow and be bound by these terms.\n' +
  '\n' +
  '\n' +
  ' --><div id="lipsum">\n' +
  '<p>\n' +
  '1.	OVERVIEW\n' +
  '</p>\n' +
  '<p>\n' +
  'Please note the following terms of service (“terms”) which govern the use of this website (“the/this website”), the mobile app and which govern the use of Cornerstone Performance Solutions’ products and the components and materials from which they are made (“products”). By using this website, app and our products, you (“the purchaser(s)” and/or “the user(s)”, whichever applies) agree that you shall follow and be bound by these terms.\n' +
  '</p>\n' +
  '<p>\n' +
  '2.	ABOUT CORNERSTONE PERFORMANCE SOLUTIONS\n' +
  '</p>\n' +
  '<p>\n' +
  'Cornerstone Performance Solutions delivers learning impact through academic qualifications, learnerships, skills programmes, short courses and specialised training programmes. Leading banks and financial services organisations turn to us when they need to ramp up the thinking and behaviour of their workforces, so they can sell more, serve better, manage risk better, become more productive, or get better business results from teams.\n' +
  '</p>\n' +
  '<p>\n' +
  '\n' +
  '\n' +
  '3.	USE OF THIS SITE\n' +
  '</p>\n' +
  '<p>\n' +
  'Users may only use this website to browse the content and make legitimate purchases. Users are not to use this website for any other purposes, including without limitation, to make any speculative, false or fraudulent purchase(s). \n' +
  '</p>\n' +
  '<p>\n' +
  'This website and the content provided herein may not be copied, reproduced, republished, uploaded, posted, transmitted or otherwise distributed. ‘Deep-linking’, ’embedding’ or using analogous technology is also strictly prohibited. Any unauthorised use of this website and/or the materials contained herein may constitute legal violations, and as such, the appropriate legal actions will be taken against unlawful users.\n' +
  '</p>\n' +
  '<p>\n' +
  '4.	DISCLAIMER OF WARRANTY\n' +
  '</p>\n' +
  '<p>\n' +
  'The contents of this website are provided “as is” without warranty of any kind, either expressed or implied. We, the providers of this website (including the owners, the authors of these contents and in general anybody connected to this site in any way, collectively called “providers”), assume no responsibility for errors or omissions amongst these contents. Further, we do not warrant, guarantee or make any representation regarding the safety, reliability, accuracy, correctness or completeness of these contents.\n' +
  '</p>\n' +
  '<p>\n' +
  'Indemnity\n' +
  '</p>\n' +
  '<p>\n' +
  'By using this site and by using Cornerstone Performance Solutions’ products, you agree to fully indemnify Cornerstone Performance Solutions and its agents and associates against any claim or demand, as well as any losses, expenses, damages, costs, resulting from the use of this site or Cornerstone Performance Solutions’ products or from any violation of these terms.\n' +
  '</p>\n' +
  '<p>\n' +
  'Exclusion of Liability\n' +
  '</p>\n' +
  '<p>\n' +
  'By using this site and by using Cornerstone Performance Solutions’ products, you agree that neither Cornerstone Performance Solutions nor its agents shall be liable to you or any other person for any form of damages or costs whatsoever arising from the use of this site or from the use Cornerstone Performance Solutions’ products, or from the inability to use this site or Cornerstone Performance Solutions’ products. Cornerstone Performance Solutions makes no guarantees nor warranties for the performance or safety of its products outside of their intended purpose.\n' +
  '</p>\n' +
  '<p>\n' +
  'The use of these contents is forbidden in those places where the law does not allow this disclaimer to take full effect.\n' +
  '</p>\n' +
  '<p>\n' +
  '5.	OUR RIGHTS\n' +
  '</p>\n' +
  '<p>\n' +
  'Cornerstone Performance Solutions reserves the right to alter these terms without express notice. It is the responsibility of the user to check regularly to determine whether these conditions have been changed. Users who find that they do not agree to any changes to these conditions must immediately stop using this website.\n' +
  '</p>\n' +
  '<p>\n' +

  'We will use our reasonable endeavours to maintain this website. This website is subject to change from time to time. Users will not be eligible for any compensation in the event that they cannot use any part of the website, or because of a failure, suspension or withdrawal of all or part of the website due to circumstances beyond our control.\n' +
  '</p>\n' +
  '<p>\n' +
  '6.	Restrictions and Copyright\n' +
  '</p>\n' +
  '<p>\n' +
  'Intellectual Property \n' +
  '</p>\n' +
  '<p>\n' +
  'This website and the content contained herein and on Cornerstone Performance Solutions’ social media accounts and press, including but not limited to imagery, designs, patterns, text, logos, insignia and video, are subject to copyright and intellectual property rights held exclusively by Cornerstone Performance Solutions and may not be copied or reproduced under any circumstances in any manner whatsoever. Such rights are protected by South African and international copyright and intellectual property laws.\n' +
  '</p>\n' +
  '<p>\n' +
  'Cornerstone Performance Solutions asserts and reserves full ownership, copyright, and intellectual property rights on all the designs, graphics, documents on our products. The designs and patterns of our products may not be copied, re-interpreted, reproduced in any manner whatsoever.\n' +
  '</p>\n' +
  '<p>\n' +
  'All learning metering © Copyright 2019 Cornerstone Performance Solutions. All rights reserved.\n' +
  '</p>\n' +
  '<p>\n' +
  '7.	THIRD-PARTY LINKS\n' +
  '</p>\n' +
  '<p>\n' +
  'In attempts to provide increased value to our Users, we may provide links to other websites or resources. You acknowledge and agree that we are not responsible for the availability of such external sites or resources, and do not endorse and are not responsible or liable, directly or indirectly, for the privacy practices or the content (including misrepresentative or defamatory content) of such websites, including (without limitation) any advertising, products or other materials or services on or available from such websites or resources, nor for any damage, loss or offence caused or alleged to be caused by, or in connection with, the use of or reliance on any such content, goods or services available on such external sites or resources.\n' +
  '</p>\n' +
  '<p>\n' +
  '8.	MONITORING\n' +
  '</p>\n' +
  '<p>\n' +
  'We have the right, but not the obligation, to monitor any activity and content associated with this website. Accordingly, we may investigate any reported violation of these conditions or complaints and take any action that we subsequently deem appropriate (which may include, but is not limited to: issuing warnings, suspending, terminating or attaching conditions to your access and/or removing any materials from this website). \n' +
  '</p>\n' +
  '<p>\n' +
  '9.	LAW\n' +
  '</p>\n' +
  '<p>\n' +
  'These conditions will be exclusively governed by and construed in accordance with the laws of South Africa, whose Courts will have exclusive jurisdiction in any dispute, save that we have the right, at our sole discretion, to commence and pursue proceedings in alternative jurisdictions.\n' +
  '</p>\n' +
  '<p>\n' +
  '10.	COMMUNICATION PREFERENCES\n' +
  '</p>\n' +
  '<p>\n' +
  'Certain personal information must be supplied by the user when completing a purchase on this website. This information includes but is not strictly limited to: billing address details, shipping address details, and personal details such as names and contact information.\n' +
  '</p>\n' +
  '<p>\n' +
  'This information is used solely for the purposes of fulfilling or otherwise managing your order. The providers will not deliberately make this information available to any third parties or use this information in any way other than what is specified here.\n' +
  '</p>\n' +
  '<p>\n' +
  'By placing an order on this website, you hereby consent to receiving electronic communications from Cornerstone Performance Solutions relating to your order and/or your order history with Cornerstone Performance Solutions. This communication may involve sending emails to your email address (and/or any other contact information provided by you) and are part of your relationship with Cornerstone Performance Solutions. Any such communication sent by the providers will contain instructions on how to update your communication preferences with Cornerstone Performance Solutions, should you wish to.\n' +
  '</p>\n' +
  '<p>\n' +
  'You agree that any notice, agreements, disclosure or other communications that we send to you electronically will satisfy any legal communication requirements, including that such communications be in writing.\n' +
  '</p>\n' +
  '<p>\n' +
  'You should maintain copies of electronic communications by printing a paper copy or saving an electronic copy. We encourage recipients to avoid printing paper copies in the interests of protecting the environment. \n' +
  '</p>\n' +
  '<p>\n' +
  'By way of completing a newsletter subscription form on this website, users explicitly provide their consent to receiving marketing communications from Cornerstone Performance Solutions in the form of email newsletters. Such newsletters typically contain information about special offers, surveys, news and promotional announcements. Users who complete a purchase on this website but do not also complete a newsletter signup form, will not be automatically subscribed to receive newsletter marketing from Cornerstone Performance Solutions. \n' +
  '</p>\n' +
  '<p>\n' +
  'Please review our Privacy Policy for further information.\n' +
  '</p>\n' +
  '<p>\n' +
  '11.	CONSENT\n' +
  '</p>\n' +
  '<p>\n' +
  'Your continued use of this website indicates that you understand and accept these terms and conditions. Furthermore, you undertake not to violate these terms in any way and acknowledge that you understand the legal implications of doing so. You further acknowledge that you will be held liable for all legal costs incurred by Cornerstone Performance Solutions for any civil or legal action deemed necessary against you for violation of these website terms.\n' +
  '</p>\n' +
  '<p>\n' +
  '12.	SECURITY POLICY\n' +
  '</p>\n' +
  '<p>\n' +
  'Cornerstone Performance Solutions is committed to providing secure online services. Encryption is used to protect the transmission of personal information when completing online transactions, and all encryption complies with international standards. \n' +
  '</p>\n' +
  '<p>\n' +
  '13.	UPDATING OF THESE TERMS AND CONDITIONS\n' +
  '</p>\n' +
  '<p>\n' +
  'We reserve the right to change, modify, add to or remove from portions or the whole of these terms and conditions from time to time and without prior notice. Alterations to these terms and conditions will become effective upon such changes being posted to this website. It is the user’s responsibility to periodically check these terms and conditions on this website for changes or updates.\n' +
  '</p>\n' +
  '<p>\n' +
  'The user’s continued use of this website following the posting of changes or updates will be considered notice of the user’s acceptance to abide by and be bound by these terms and conditions, including such alterations.\n' +
  '</p>\n' +
  '<p>\n' +
  'Your continued use of this website following the posting of changes to these terms will mean that you accept those changes. You agree not to use the site or any materials you may obtain through the site in a manner that violates any law. You also agree not to use the site to stalk, harass, or harm another individual, to impersonate any person or entity or otherwise misrepresent your affiliation with a person or entity. \n' +
  '</p>\n' +
  '<p>\n' +
  'You further agree not to interfere with or disrupt the site, servers or networks connected to the site or to use any data mining, robots, or similar data gathering or extraction methods or attempt to gain unauthorized access to any portion of the site or any other accounts, computer systems, or networks connected to the site, whether through hacking, password mining, or any other means. We may terminate or restrict your use of this site, without compensation or notice if you are, or if we suspect that you are (i) in violation of any of these terms or (ii) engaged in illegal or improper use of this site.\n' +
  '</p>\n' +
  '<p>\n' +
  '14.	CONTACT US:\n' +
  '</p>\n' +
  '<p>\n' +
  'Physical address:\n' +
  '39 Grove Street. \n' +
  'Randburg\n' +
  'Johannesburg\n' +
  'South Africa\n' +
  '</p>\n' +
  '<p>\n' +
  
  'Telephone: +27 11 789 1957\n' +
  '</p>\n' +
  '<p>\n' +
  'Email Address: info@performancesolutions.co.za\n' +
  '</p>\n' +
  '</p></div>\n' +
  '</div>\n' +
  '<div id="bannerL"><div id="div-gpt-ad-1474537762122-2">\n' +
  '</div></div>\n' +
  '</div></div>',
};
/* eslint-enable */

export const chartConfig = {
  type: 'pie',
  depth3D: 0,
  pullOutRadius: 30,
  pulledField: 'pulled',
  showBalloons: false,
  startDuration: 0,
  gradientType: 'linear',
  gradientRatio: [0, 0],
  color: '#fff',
  fontSize: 16,
  hideLabelsPercent: 5,
  fontFamily: 'Roboto-Bold',
  balloon: {
    enabled: false,
  },
  titleField: 'value',
  valueField: 'value',
  labelText: '[[title]]',
  labelRadius: -40,
};



// WEBPACK FOOTER //
// ./src/constants.js